module.exports = __webpack_public_path__ + "img/03.3c75abe0.jpg";